// extracted by mini-css-extract-plugin
export default {"whiteLoader":"SpinLoader_whiteLoader__rDQR2","spin":"SpinLoader_spin__Ngnbe","loader":"SpinLoader_loader__S1aZr"};